import React from 'react';
import Cctv from './Cctv';
import Panel from './Panel';
import data from '../data/data.json';
import roadways from '../data/roadways.json';
import panels from '../data/panels.json';
import { Grid } from '@mui/material';
// redux
import { connect } from 'react-redux';

// vr1madeira.pt gates camera images behind a session+token dance the
// browser can't do cross-origin, so we proxy through our own function.
// process.env.NODE_ENV (not window.location.hostname) so CRA's build
// statically eliminates the emulator branch - and its literal URL - from
// the production bundle entirely, instead of just never taking it at runtime.
const FUNCTIONS_BASE = process.env.NODE_ENV === 'development'
    ? 'http://localhost:5001/viarapida1/us-central1'
    : 'https://us-central1-viarapida1.cloudfunctions.net';

const Body = (props) => {

    let filteredData = data;
    if (props.roadway.roadway === "norte")
        filteredData = filteredData.filter(cctv => roadways[0].cctvs.indexOf(cctv.image) > -1)
    if (props.roadway.roadway === "sul")
        filteredData = filteredData.filter(cctv => roadways[1].cctvs.indexOf(cctv.image) > -1)
    //console.log("Body, loadstage", props.loadStage, props.roadway,filteredData)


    let items = []
    filteredData.forEach(cctv => {
        // create cctv panel component
        let cctv_panels = panels.filter(panel => panel.cctv === cctv.image)
        let cctv_panels_components = []
        cctv_panels.forEach(cctv_panel => {
            const cctv_panel_data = props.panelsData.filter(paneldata => paneldata.id === cctv_panel.id)[0]
            if (cctv_panel_data)
                cctv_panels_components.push({ id: cctv_panel_data.id, sentido: cctv_panel_data.s || cctv_panel.sentido, comp: <Panel text={cctv_panel_data.text} image={cctv_panel_data.img} sentido={cctv_panel_data.s || cctv_panel.sentido} /> })
        })

        // create cctv component
        const cctvProps = {}
        cctvProps.uri = `${FUNCTIONS_BASE}/getCctvImage?image=${cctv.image}&type=${cctv.type}`
        cctvProps.component = "img"
        if (props.loadStage === "loaded" && cctv.image === "065") {
            cctvProps.onLoad = props.handleOnLoad
            cctvProps.eager = true
        }

        const cctvC = <Cctv
            name={cctv.name}
            junction={cctv.junction}
            {...cctvProps}
        />

        // push to grid
        cctv_panels_components.forEach(cctv_panel_component => {
            if (cctv_panel_component.sentido === "sul" && props.roadway.roadway !== "norte")
                items.push({ id: `panel_${cctv_panel_component.id}`, component: cctv_panel_component.comp })
        })

        items.push({ id: `${cctv.image}`, component: cctvC })

        cctv_panels_components.forEach(cctv_panel_component => {
            if (cctv_panel_component.sentido === "norte" && props.roadway.roadway !== "sul")
                items.push({ id: `panel_${cctv_panel_component.id}`, component: cctv_panel_component.comp })
        })
    })

    if (props.loadStage === "loading") return null;
    return (
        <Grid container spacing={2} style={{ maxWidth: "600px" }} >
            {items.map(item => {
                return <Grid item xs={12} key={item.id} id={item.id}>
                    {item.component}
                </Grid>
            })}
        </Grid>
    )
};

const mapStateToProps = (state) => ({
    roadway: state.roadway,
    loadStage: state.loadStage,
    panelsData: state.panelsData,
});

const BodyContainer = connect(mapStateToProps)((Body));

export default BodyContainer;
